import { render } from "./BroadcastAdminComponent.vue?vue&type=template&id=701b99df&scoped=true&ts=true"
import script from "./BroadcastAdminComponent.vue?vue&type=script&lang=ts"
export * from "./BroadcastAdminComponent.vue?vue&type=script&lang=ts"

import "./BroadcastAdminComponent.vue?vue&type=style&index=0&id=701b99df&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701b99df"]])

export default __exports__